import type { RenderAdOptions } from './types'

const pending = new Map<string, RenderAdOptions>()

export function setRenderOptions(adUnitCode: string, options: RenderAdOptions | undefined): void {
    if (options) {
        pending.set(adUnitCode, options)
    } else {
        pending.delete(adUnitCode)
    }
}

export function takeRenderOptions(adUnitCode: string): RenderAdOptions | undefined {
    const options = pending.get(adUnitCode)
    pending.delete(adUnitCode)
    return options
}
